import {
	Component,
	SimpleChanges,
	OnChanges,
	OnInit,
	Output,
	Input,
	EventEmitter,
	ChangeDetectionStrategy,
} from "@angular/core";

import {FormGroup, FormControl, FormBuilder} from "@angular/forms";
interface IHeaders {
	field?: string;
	label?: string;
	type?: string;
	choices?: any[];
	op?: string;
	data?: any;
	mode?: string;
}
@Component({
	selector: "app-search-date-filter",
	template: `
		<div class="field" *ngIf="field.field === 'verificationYear'">
			<div class="ui left icon input">
				<i class="calendar icon"></i>
				<input suiDatepicker [(ngModel)]="field.data" pickerMode="year" [pickerUseNativeOnMobile]="false" />
			</div>
		</div>

		<div class="field" *ngIf="(
			field.field != 'dateOfRegistration'
			&&
			field.field != 'verificationYear'
			&&
			field.mode != 'date'
		)">
			<div class="ui left icon input">
				<i class="calendar icon"></i>
				<input suiDatepicker [(ngModel)]="field.data" [pickerMode]="mode" [pickerUseNativeOnMobile]="false" />
			</div>
		</div>

		<div class="field" *ngIf="field.field === 'dateOfRegistration' || field.mode === 'date'">
			<div class="ui left icon input">
				<i class="calendar icon"></i>
				<input suiDatepicker [(ngModel)]="field.data" pickerMode="date" [pickerUseNativeOnMobile]="false" />
			</div>
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateFilter implements OnChanges {
	mode = "datetime";
	searchFrom = {};
	searchTo = {};

	@Input() field: IHeaders;
	_field: IHeaders;
	@Input() index: number;

	@Output() query = new EventEmitter();

	ngOnChanges(changes: any): void {
		if (changes["field"] !== undefined) {
			let fields: IHeaders = Object.assign({}, this.field);
		}
	}

	queryDateRangeTo(event) {
		this.field.data = event.toISOString().split(".")[0];
		this.query.emit({field: this.field, index: this.index});
	}
}
